import { TranslateService } from "@ngx-translate/core";
import { SubmenuService } from "./submenu.service";

export class SubmenuItem {
    public title:string;
    public url:string;
    public type:string;

    constructor(public translate: TranslateService){
           
    }


    public static CreateNew(url:string, ts:TranslateService):SubmenuItem
    {
       return SubmenuItem.Create(ts.instant('HOME.SUBMENU_ADDNEW'), url, "create", ts);
    }

    public static CreateSubmit(ts:TranslateService):SubmenuItem
    {
           return SubmenuItem.Create(ts.instant('HOME.SUBMENU_SAVE'), null, "submit", ts);
    }

    public static CreateDelete(ts:TranslateService):SubmenuItem
    {
           return SubmenuItem.Create(ts.instant('HOME.SUBMENU_DELETE'), null, "delete", ts);
    }

    public static Create(title:string, url:string, type:string, ts:TranslateService):SubmenuItem
    {
          let newItem =  new SubmenuItem(ts);

          newItem.title = title;
          newItem.url = url;
          newItem.type = type;
          return newItem;
    }
}
